// Utils/auth.js

let authState = {
  token: null,
  isRanByCypress: false,
};

export const setAuthState = (newState) => {
  authState = { ...authState, ...newState };
};

export const getAuthState = () => {
  return authState;
};
